module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/pod.cbb0a7b1.svg";